import { render, staticRenderFns } from "./TaxIncome.vue?vue&type=template&id=1373bb3f&scoped=true&"
import script from "./TaxIncome.vue?vue&type=script&lang=js&"
export * from "./TaxIncome.vue?vue&type=script&lang=js&"
import style0 from "./TaxIncome.vue?vue&type=style&index=0&id=1373bb3f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1373bb3f",
  null
  
)

export default component.exports